import { atom } from "jotai";

export const showHeaderStoreInitialState: boolean = true;

export const ShowHeaderStore = atom(showHeaderStoreInitialState);
